
  <div id="modalvehicles">

        <div class="modal-content" style="padding-bottom: 50px;padding: 3em 4.5em;">
          <div class="d-flex justify-content-between mx-auto" style="width: 98%">

              <p *ngIf="service && service['vehicles'] && service['vehicles'][0]['vehicle'].type" class="title mb-0 mt-2" style="font-family: 'Rubik', sans-ferif;font-size: 30px;font-weight: 400;line-height: 1 !important; color: #3f3f3f !important;">
                {{ service['vehicles'][0]['vehicle'].type}}
              </p>

              <p *ngIf="vehicles && vehicles.length > 0 && vehicles[0]['vehicle']?.type" class="title mb-0 mt-2" style="font-family: 'Rubik', sans-ferif;font-size: 30px;font-weight: 400;line-height: 1 !important; color: #3f3f3f !important;">
                {{  vehicles[0]['vehicle']?.type}
              </p>


            <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
              <span aria-hidden="true" style="font-size: 60px; font-weight: 100;">&times;</span>
            </button>
        </div>
      <div class="modal-body py-2">
        <usb-vehicle
                      [vehicles]="service['vehicles'] || vehicles"
                      [infoTransfer]="form"
                      [fliyingInfo]="fliyingInfo"
                      [formTransport]="formTransport"
                      [clientSetting]="clientSetting"
                      [currencies]="currencies"
                      [currencyAgency]="currencyAgency"
                      [paymentAgencyActive]="paymentAgencyActive"
                      [tabActive]="tabActive"
                      [payload]="payload"
                      [action]="action"
                      [arrayResults]="arrayResults"
                      [quote]="quote"
                      (selectVehicleContinue)="continue($event)"
                      (selectOneVehicleDoubleWay)="selectOneVehicleDoubleWay($event)"
                      (closeModalComents)="close()"
                      >
        </usb-vehicle>
      </div>
  </div>
</div>
